import { FaCopy, FaTrashAlt } from "react-icons/fa";
import { formatDate, Text } from "../../../modules/Dashboard";
import { FlexColumn, FlexCenter } from "../../../styles/CommonStyles";
import { useCopyToClipboard } from "../../../core/hooks/useCopyToClipboard";
import { formatDateShort } from "../../plans/components/CurrentUserPlan/helper";
import { BiCopy } from "react-icons/bi";

export const InviteCard = ({ item, lang, openDeleteModal }) => {
    const { copyToClip } = useCopyToClipboard();

    return (
        <div className="rounded-xl border border-[#AD46FF33] bg-[#0F172B80] p-4 flex justify-between gap-4 relative">

            {/* LEFT SIDE */}
            <FlexColumn className="gap-3 w-full">
                <div>
                    <Text tid={"invite-code"} className="text-[#DAB2FF]" />
                    <div className="text-xl md:text-2xl font-bold ">
                        {item.code}
                    </div>
                </div>

                <div className="text-xs text-[#DAB2FF]">
                    {formatDateShort(
                        item.createdAt,
                        lang
                    )}
                </div>

                <UsageProgress used={item.used} max={item.maxUse} />
            </FlexColumn>

            {/* RIGHT SIDE */}
            <div className="absolute top-8 ltr:right-4 rtl:left-4">
                <FlexCenter className="gap-2">
                    <button
                        onClick={() => copyToClip(item.code)}
                        className="flex items-center gap-2 text-mainColor text-sm bg-[#9810FA] p-2 sm:p-3 rounded-lg"
                    >
                        <BiCopy color="#ffffff" size={16} />
                        <Text tid="copy-code" className="hidden md:inline" />
                    </button>

                    <button
                        onClick={() => openDeleteModal(item._id)}
                        className="flex items-center gap-2 bg-[#E7000B33] p-2 sm:p-3 rounded-lg border border-[#FB2C364D]"
                    >
                        <FaTrashAlt color="#FF6467" />
                    </button>
                </FlexCenter>
            </div>
        </div>
    );
};


const UsageProgress = ({ used, max }) => {
    const percent = Math.min((used / max) * 100, 100);
    const remaining = Math.max(max - used, 0);

    return (
        <div className="w-full space-y-2 relative mt-2">
            <div className=" text-[#FDC700] absolute ltr:right-0 rtl:left-0 -top-0">
                {used} / {max}
            </div>
            <Text tid={"usage"} className="text-[#DAB2FF]" />
            <div className="h-3 w-full bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
                <div
                    className="h-full bg-[#DAB2FF] transition-all"
                    style={{ width: `${percent}%` }}
                />
            </div>
            {/* Remaining */}
            <div className="text-xs text-[#DAB2FF]">
                {remaining}{" "}
                <Text tid="remaining" className="inline text-inherit" />
            </div>
        </div>
    );
};
